module.exports = __webpack_public_path__ + "img/cass-logo-square.8ddc73c9.png";